module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00071-fs8.901adbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00071-fs8.png
// module id = 224
// module chunks = 0